import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../Api/Config";
import { useParams, useNavigate } from "react-router-dom";

export default function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isValidToken, setIsValidToken] = useState(null);

    // Validate token on component mount
    useEffect(() => {
        validateToken();
    }, [token]);

    const validateToken = async () => {
        try {
            const res = await fetch(`${BASE_URL}/reset-password//${token}`);
            setIsValidToken(res.ok);
            if (!res.ok) {
                setMessage("Invalid or expired reset link");
            }
        } catch (err) {
            setIsValidToken(false);
            setMessage("Unable to validate reset link");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate passwords match
        if (password !== confirmPassword) {
            setMessage("Passwords do not match");
            return;
        }

        if (password.length < 6) {
            setMessage("Password must be at least 6 characters long");
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(`${BASE_URL}/auth/reset-password/${token}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password })
            });

            const data = await res.json();
            setMessage(data.message);

            if (res.ok) {
                setTimeout(() => {
                    navigate('/'); // Redirect to login after successful reset
                }, 2000);
            }
        } catch (err) {
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    if (isValidToken === false) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
                <div className="w-full max-w-md bg-white shadow-lg rounded-xl p-6 text-center">
                    <h2 className="text-2xl font-bold text-red-500 mb-4">Invalid Link</h2>
                    <p className="text-gray-600">{message}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
            <div className="w-full max-w-md bg-white shadow-lg rounded-xl p-6">
                <h2 className="text-2xl font-bold text-center mb-6">Reset Password</h2>
                {message && (
                    <div className={`mb-4 text-center text-sm ${message.includes('successful') ? 'text-green-500' : 'text-red-500'
                        }`}>
                        {message}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="password"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                        placeholder="New password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                    />
                    <input
                        type="password"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength={6}
                    />
                    <button
                        type="submit"
                        disabled={loading || !password || !confirmPassword}
                        className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg transition disabled:opacity-50"
                    >
                        {loading ? "Updating..." : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}